import { apiClient } from './apiClient';
import type {
  ClientAnalyticsDashboard,
  ClientAnalyticsEmbedConfig,
} from '@/types/clientAnalytics';

// Fetches one client's analytics dashboard from the backend contract endpoint.
// The backend picks the data source (AgencyAnalytics REST or fixture); the
// frontend only reads the shape.
export const clientAnalyticsService = {
  async getEmbedConfig(website: string): Promise<ClientAnalyticsEmbedConfig> {
    const { data } = await apiClient.get<ClientAnalyticsEmbedConfig>(
      `/client-analytics/${encodeURIComponent(website)}/embed-config`,
    );
    return data;
  },

  async getDashboard(
    website: string,
    params?: { period_start?: string; period_end?: string },
  ): Promise<ClientAnalyticsDashboard> {
    const { data } = await apiClient.get<ClientAnalyticsDashboard>(
      `/client-analytics/${encodeURIComponent(website)}`,
      { params },
    );
    return data;
  },
};
